import { useState } from 'react';

interface ConnectClaudeInstructionsProps {
  title?: string;
  intro: string;
  claudeCodeDescription: string;
  claudeDesktopDescription: string;
  footer: string;
}

export default function ConnectClaudeInstructions({
  title = 'Connect Claude',
  intro,
  claudeCodeDescription,
  claudeDesktopDescription,
  footer,
}: ConnectClaudeInstructionsProps) {
  const [copiedField, setCopiedField] = useState<string | null>(null);
  const mcpUrl = import.meta.env.VITE_MCP_URL || 'https://exhibit-mcp.chattermill.workers.dev';
  const claudeCodeCmd = `claude mcp add exhibit --transport http ${mcpUrl}`;

  const copyToClipboard = (text: string, field: string) => {
    navigator.clipboard.writeText(text);
    setCopiedField(field);
    window.setTimeout(() => setCopiedField(null), 2000);
  };

  return (
    <section>
      <h2
        className="text-[16px] font-semibold mb-[var(--sp-4)]"
        style={{ color: 'var(--color-text-neutral-strong)' }}
      >
        {title}
      </h2>
      <div
        className="rounded-[var(--radius-md)] p-[var(--sp-5)] border"
        style={{
          background: 'var(--color-surface-neutral-default)',
          borderColor: 'var(--color-border-neutral-subtle-default)',
        }}
      >
        <p
          className="text-[14px] mb-[var(--sp-4)]"
          style={{ color: 'var(--color-text-neutral-medium)' }}
        >
          {intro}
        </p>

        <div
          className="rounded-[var(--radius-md)] p-[var(--sp-4)] mb-[var(--sp-3)]"
          style={{ background: 'var(--color-surface-neutral-subtle-default)' }}
        >
          <p className="text-[13px] font-semibold mb-[var(--sp-2)]" style={{ color: 'var(--color-text-neutral-strong)' }}>
            Claude Code
          </p>
          <p className="text-[13px] mb-[var(--sp-2)]" style={{ color: 'var(--color-text-neutral-subtle)' }}>
            {claudeCodeDescription}
          </p>
          <div className="flex gap-[var(--sp-2)]">
            <div
              className="flex-1 px-[var(--sp-3)] py-[var(--sp-2)] rounded-[var(--radius-sm)] font-mono text-[13px] overflow-x-auto whitespace-nowrap border"
              style={{
                background: 'var(--color-surface-neutral-medium-default)',
                borderColor: 'var(--color-border-neutral-subtle-default)',
                color: 'var(--color-text-neutral-strong)',
              }}
            >
              {claudeCodeCmd}
            </div>
            <button
              onClick={() => copyToClipboard(claudeCodeCmd, 'claude-code')}
              className="h-[36px] px-[var(--sp-3)] rounded-[var(--radius-sm)] text-[13px] font-semibold cursor-pointer border-0 text-white flex-shrink-0 transition-colors duration-[120ms]"
              style={{ background: copiedField === 'claude-code' ? 'var(--color-surface-positive-medium-default)' : 'var(--color-surface-action-strong-default)' }}
            >
              {copiedField === 'claude-code' ? 'Copied!' : 'Copy'}
            </button>
          </div>
        </div>

        <div
          className="rounded-[var(--radius-md)] p-[var(--sp-4)] mb-[var(--sp-3)]"
          style={{ background: 'var(--color-surface-neutral-subtle-default)' }}
        >
          <p className="text-[13px] font-semibold mb-[var(--sp-2)]" style={{ color: 'var(--color-text-neutral-strong)' }}>
            Claude Desktop / Claude.ai
          </p>
          <p className="text-[13px] mb-[var(--sp-2)]" style={{ color: 'var(--color-text-neutral-subtle)' }}>
            {claudeDesktopDescription}
          </p>
          <div className="flex gap-[var(--sp-2)]">
            <div
              className="flex-1 px-[var(--sp-3)] py-[var(--sp-2)] rounded-[var(--radius-sm)] font-mono text-[13px] overflow-x-auto whitespace-nowrap border"
              style={{
                background: 'var(--color-surface-neutral-medium-default)',
                borderColor: 'var(--color-border-neutral-subtle-default)',
                color: 'var(--color-text-neutral-strong)',
              }}
            >
              {mcpUrl}
            </div>
            <button
              onClick={() => copyToClipboard(mcpUrl, 'url')}
              className="h-[36px] px-[var(--sp-3)] rounded-[var(--radius-sm)] text-[13px] font-semibold cursor-pointer border-0 text-white flex-shrink-0 transition-colors duration-[120ms]"
              style={{ background: copiedField === 'url' ? 'var(--color-surface-positive-medium-default)' : 'var(--color-surface-action-strong-default)' }}
            >
              {copiedField === 'url' ? 'Copied!' : 'Copy'}
            </button>
          </div>
        </div>

        <div
          className="rounded-[var(--radius-md)] p-[var(--sp-4)]"
          style={{ background: 'var(--color-surface-neutral-subtle-default)' }}
        >
          <p className="text-[13px] font-semibold mb-[var(--sp-2)]" style={{ color: 'var(--color-text-neutral-strong)' }}>
            Other MCP clients
          </p>
          <p className="text-[13px]" style={{ color: 'var(--color-text-neutral-subtle)' }}>
            {footer}
          </p>
        </div>
      </div>
    </section>
  );
}
